import IconButton from "@material-ui/core/IconButton";
import BuildIcon from "@material-ui/icons/Build";
import { Menu, MenuItem } from "@material-ui/core";
import React from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import withIntl from "../../utils/withIntl";
import { updateArrangement } from "../../store/ArrangementApi";
import EditIcon from "@material-ui/icons/Edit";

function ActionButtonArrangement(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  return (
    <div>
      <IconButton
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        variant="standard"
      >
        <BuildIcon colo={"primary"} />
      </IconButton>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            props.handleOpenArrangementSettingsDialog();
            setAnchorEl(null);
          }}
        >
          <EditIcon color="primary" />
          {props.intl.formatMessage({ id: "edit_article" })}
        </MenuItem>
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            if (window.confirm(props.intl.formatMessage({ id: "are_you_sure_you_want_to_delete_arrangement" }))) {
              updateArrangement(props.spMerchantId, props.arrangement, { deleted_at: "deleted" });
            }
            setAnchorEl(null);
          }}
        >
          <DeleteIcon color="primary" />
          {props.intl.formatMessage({ id: "delete_article" })}
        </MenuItem>
      </Menu>
    </div>
  );
}

export default withIntl(ActionButtonArrangement);
